import React, { useEffect, useState } from "react";

const SummaryCard = ({ summaryData }) => {
  const [riskRewardRatio, setRiskRewardRatio] = useState("");
  const [epl, setEpl] = useState(summaryData.entryPriceLower);
  const [sl, setSl] = useState(summaryData.stoploss);
  const [tp, setTp] = useState(summaryData.targetPrice);

  function calculateRatio(entryL, stoploss, target) {
    return ((entryL - stoploss) / (target - entryL)).toFixed(2);
  }

  function formatRatio(ratio) {
    if (ratio) {
      const fraction = parseFloat(ratio);
      const precision = 1e9;

      let numerator = Math.round(fraction * precision);
      let denominator = precision;

      // Find greatest common divisor (GCD) to simplify the fraction
      const gcd = (a, b) => (b ? gcd(b, a % b) : a);
      const gcdValue = gcd(numerator, denominator);

      numerator /= gcdValue;
      denominator /= gcdValue;

      return { risk: numerator, reward: denominator };
    }
  }

  useEffect(() => {
    console.log(epl, sl, tp);
    const ratio = calculateRatio(epl, sl, tp);
    console.log(ratio);
    if (ratio) {
      const formattedRatio = formatRatio(ratio);
      setRiskRewardRatio(
        `1 : ${(formattedRatio.reward / formattedRatio.risk).toFixed(2)}`
      );
      console.log(riskRewardRatio);
    }
  }, []);

  return (
    <div className="px-12 pr-12 mt-8 max-[1200px]:px-8 max-[992px]:px-6 max-[768px]:px-4">
      {
        <div className="border-l-8 border-[rgba(21,105,171,0.49)]">
          <div className="text-base flex justify-between border-b border-[#ebebeb] py-[1.7rem] pr-8 pl-12 max-[1200px]:flex-wrap max-[1200px]:gap-5 max-[1200px]:justify-around max-[1200px]:py-5 max-[1200px]:px-6 max-[992px]:gap-4 max-[768px]:flex-col max-[768px]:items-stretch max-[768px]:justify-start max-[768px]:gap-3 max-[768px]:p-4">
            <div className="flex flex-col items-center max-[992px]:min-w-[140px] max-[768px]:items-center">
              <p className="font-semibold max-[768px]:text-base">
                {summaryData?.confidence} %
              </p>
              <p className="text-center text-[0.7rem] max-[768px]:text-xs">
                Confidence
              </p>
            </div>

            <div className="flex flex-col items-center max-[992px]:min-w-[140px] max-[768px]:items-center">
              <p className="font-semibold max-[768px]:text-base">
                {summaryData.tradeType ? summaryData.tradeType : "No Data"}
              </p>
              <p className="text-center text-[0.7rem] max-[768px]:text-xs">
                Mode
              </p>
            </div>

            <div className="flex flex-col items-center md:min-w-[140px] sm:items-center">
              <p className="font-semibold sm:text-base">
                {summaryData?.entryPriceLower}-{summaryData?.entryPriceUpper}
              </p>
              <p className="text-center text-[0.7rem] max-[768px]:text-xs">
                Entry price range
              </p>
            </div>
            <div className="flex flex-col items-center max-[992px]:min-w-[140px] max-[768px]:items-center">
              <p className="font-semibold max-[768px]:text-base">
                {summaryData?.duration} days
              </p>
              <p className="text-center text-[0.7rem] max-[768px]:text-xs">
                Target Duration
              </p>
            </div>
          </div>

          <div className="text-base flex justify-between py-[1.7rem] px-32 max-[1200px]:flex-wrap max-[1200px]:gap-5 max-[1200px]:justify-around max-[1200px]:py-5 max-[1200px]:px-8 max-[992px]:gap-4 max-[768px]:flex-col max-[768px]:items-stretch max-[768px]:justify-start max-[768px]:gap-3 max-[768px]:p-4">
            <div className="flex flex-col items-center max-[992px]:min-w-[140px] max-[768px]:items-center">
              <p className="font-semibold max-[768px]:text-base">
                {summaryData?.targetPrice}
              </p>
              <p className="text-center text-[0.7rem] max-[768px]:text-xs">
                Target
              </p>
            </div>

            <div className="flex flex-col items-center max-[992px]:min-w-[140px] max-[768px]:items-center">
              <p className="font-semibold max-[768px]:text-base">
                {summaryData?.stoploss}
              </p>
              <p className="text-center text-[0.7rem] max-[768px]:text-xs">
                Stop Loss
              </p>
            </div>

            <div className="flex flex-col items-center max-[992px]:min-w-[140px] max-[768px]:items-center">
              <p className="font-semibold max-[768px]:text-base">
                {riskRewardRatio}
              </p>
              <p className="text-center text-[0.7rem] max-[768px]:text-xs">
                Risk : Reward
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default SummaryCard;
